import React from 'react';
import {
  Field,
  mergeClasses,
  makeStyles,
  tokens,
  Combobox,
  Option,
  useId,
} from '@fluentui/react-components';
import { SearchFilled } from '@fluentui/react-icons';
import _ from 'underscore';

interface EntitySelectorProps {
  entities?: Array<{ name: string, id: string }>;
  value: string,
  onSelectEntity: (event: any, data: any) => void;
  label: string;
  placeholder: string;
  disabled?: boolean;
  errorMessage?: string;
}

export const useEntitySelectorStyles = makeStyles({
  entityName: {
    display: 'grid',
  },
  label: {
    lineHeight: tokens.lineHeightBase200,
    paddingTop: tokens.spacingVerticalSNudge,
    paddingBottom: tokens.spacingVerticalSNudge,
    '& label': {
      fontWeight: tokens.fontWeightRegular,
    },
  },
  combobox: {
    height: '30px',
    minWidth: 'fit-content',
  },
});

export const EntitySelector: React.FC<EntitySelectorProps> = ({
  entities,
  onSelectEntity,
  label,
  placeholder,
  disabled,
  value,
  errorMessage,
}) => {
  const styles = useEntitySelectorStyles();
  const labelId = useId('entity-selector');

  return (
    <div className={mergeClasses('entity-selector', styles.entityName)}>
      <Field
        size="small"
        label={label}
        className={styles.label}
        validationMessage={errorMessage}
        validationState={_.isEmpty(errorMessage) ? 'none' : 'error'}
      >
        <Combobox
          readOnly
          value={value}
          aria-labelledby={labelId}
          placeholder={placeholder}
          expandIcon={<SearchFilled />}
          onOptionSelect={onSelectEntity}
          disabled={disabled}
          autoComplete="on"
          className={styles.combobox}
        >
          {entities && entities.map((entity:{ name: string, id: string }) => (
            <Option key={entity.id} value={entity.id}>
              {entity.name}
            </Option>
          ))}
        </Combobox>
      </Field>
    </div>
  );
};
